import React, { FC } from "react";

import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import { ResourceType } from "../../utils";

const ExtensionList: FC<
  React.PropsWithChildren<{
    resourceType: ResourceType;
    overloadedExtensionKey?: string;
  }>
> = function ({ resourceType, overloadedExtensionKey }) {
  const { t } = useTranslation();
  const keyExtension =
    overloadedExtensionKey ?? `admin:resource.upload.file.extensions.${resourceType}`;
  return (
    <>
      {resourceType !== ResourceType.UNKNOWN && resourceType !== ResourceType.FONT && (
        <Box>{t(`admin:resource.upload.file.recommendation.${resourceType}`)}</Box>
      )}
      {resourceType !== ResourceType.VIDEO && <Box>{t(keyExtension)}</Box>}
    </>
  );
};
export default ExtensionList;
